module.exports = __webpack_public_path__ + "img/collapse-closed.6834eee2.svg";